import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';
import { H2 } from '../../components';
import { useIntl } from 'react-intl';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const intl = useIntl();
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return text ? (
    <section className={css.sectionText}>
      <H2 className={css.sectionHeadingWithExtraMargin}>{intl.formatMessage({ id: 'ListingPage.overview' })}</H2>
      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
